import {
  ActionIcon,
  Box,
  Group,
  Loader,
  Text,
  TextInput,
  rem,
} from "@mantine/core";
import { IconDots, IconSearch } from "@tabler/icons-react";
import { RowData } from "../../../types";
import { formatDate } from "../../../utils/date";
import CustomTable from "../../../components/tables/CustomTable";
import { useProperties } from "../../../hooks/useProperties";

export default function PropertyList() {
  const { useListProperties } = useProperties();
  const { properties, loading } = useListProperties();

  const headers = [
    { label: "Property Name", accessor: "propertyName" },
    { label: "Location", accessor: "location" },
    { label: "Owner", accessor: "owner" },
    { label: "Created At", accessor: "createdAt" },
    { label: "", accessor: "menu" },
  ];

  const data = properties?.map((property) => ({
    id: property.id,
    propertyName: <Text size="sm">{property.propertyName}</Text>,
    location: <Text size="sm">{property.location}</Text>,
    owner: (
      <Text size="sm" tt="capitalize">
        {property?.Client_tbl?.name}
      </Text>
    ),
    createdAt: (
      <Text size="sm">
        {property.createdAt ? formatDate(property.createdAt) : "--"}
      </Text>
    ),
    menu: "__commonData__",
  }));

  const commonData = {
    menu: (rowData: RowData) => (
      <ActionIcon variant="subtle">
        <IconDots size={24} stroke={1.5} />
      </ActionIcon>
    ),
  };

  return (
    <Box py={"md"}>
      {loading ? (
        <Group justify="center" my={"md"}>
          <Loader size={"sm"} />
          <Text>Loading...</Text>
        </Group>
      ) : (
        <Box>
          <Group justify="space-between">
            <TextInput
              variant="filled"
              leftSection={<IconSearch size={20} stroke={1.5} />}
              w={rem(250)}
              placeholder="Search property"
              styles={() => ({
                input: {
                  backgroundColor: "#f5f9fd",
                },
              })}
            />
          </Group>
          <CustomTable headers={headers} rows={data} commonData={commonData} />
        </Box>
      )}
    </Box>
  );
}
